import {
   REQUEST_GUEST_TOKEN,
   RECEIVE_GUEST_TOKEN,
   RECEIVE_LOGIN_TOKEN,
   REQUEST_EXIST_ACCOUNT,
   LOADING_LOGIN,
   LOG_OUT,
   SHOW_LEGAL_MODAL,
   HIDE_LEGAL_MODAL,
   SHOW_DATA_PRIVACY_MODAL,
   HIDE_DATA_PRIVACY_MODAL,
   SHOW_REGISTER_SUCCESS_MODAL,
   HIDE_REGISTER_SUCCESS_MODAL
} from '../Constants/actionTypes';
import Cookies from 'universal-cookie';
import moment from 'moment';
const cookies = new Cookies();

const INITIAL_STATE = {
   userToken: cookies.get('userToken') || '',
   status: false,
   errorcode: '',
   message: '',
   isLoading: false,
   email: '',
   dataPrivacyModalShown: false,
   legalModal: {
      visible: false,
      providerType: '',
      payload: {}
   },
   registerSuccessModalShown: false
};

const Authentication = (state = INITIAL_STATE, action) => {
   switch (action.type) {
      case REQUEST_GUEST_TOKEN:
         return Object.assign({}, state, {
            isLoading: action.isLoading
         });
      case RECEIVE_GUEST_TOKEN:
         cookies.set('userToken', action.userToken, {
            expires: moment().add(1, 'd').toDate(),
            path: '/'
         });
         if (state.userToken === action.userToken) {
            return state;
         } else {
            return {
               ...state,
               userToken: action.userToken,
               status: false
            };
         }
      case RECEIVE_LOGIN_TOKEN:
         cookies.set('userToken', action.userToken, {
            expires: moment().add(1, 'd').toDate(),
            path: '/'
         });
         if (state.userToken === action.userToken) {
            return state;
         } else {
            return {
               ...state,
               userToken: action.userToken,
               status: true
            };
         }
      case LOG_OUT:
         return {
            ...state,
            userToken: action.userToken,
            status: false
         };
      case LOADING_LOGIN:
         return {
            ...state,
            loading: action.loading
         };
      case REQUEST_EXIST_ACCOUNT:
         return Object.assign({}, state, {
            email: action.email
         });
      case SHOW_DATA_PRIVACY_MODAL:
         return {
            ...state,
            dataPrivacyModalShown: true
         };
      case HIDE_DATA_PRIVACY_MODAL:
         return {
            ...state,
            dataPrivacyModalShown: false
         };
      case SHOW_LEGAL_MODAL:
         return {
            ...state,
            legalModal: action.payload
         };
      case HIDE_LEGAL_MODAL:
         return {
            ...state,
            legalModal: {
               visible: false,
               onSignIn: () => {}
            }
         };
      default:
         return state;
   }
};
export default Authentication;
